import { render } from "./UzbekistanPage.vue?vue&type=template&id=470ad606&scoped=true"
import script from "./UzbekistanPage.vue?vue&type=script&lang=js"
export * from "./UzbekistanPage.vue?vue&type=script&lang=js"

import "./UzbekistanPage.vue?vue&type=style&index=0&id=470ad606&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470ad606"]])

export default __exports__